import { render, staticRenderFns } from "./smsrecharge.vue?vue&type=template&id=feda813c&"
import script from "./smsrecharge.vue?vue&type=script&lang=ts&"
export * from "./smsrecharge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "smsrecharge.vue"
export default component.exports